const favoriteImages = [
  "/questions/coordinator.jpg",
  "/questions/director.jpg",
  "/questions/helper.jpg",
  "/questions/inspirer.jpg",
  "/questions/motivator.jpg",
  "/questions/observer.jpg",
  "/questions/reformer.jpg",
  "/questions/supporter.jpg",
];
export default favoriteImages;
